import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=5f0d5a8c"
import script from "./CategorySlider.vue?vue&type=script&lang=js"
export * from "./CategorySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports